//{{-- -------------------------------------------------------------------------------- --}}
//{{-- This code handles both DatePicker and DateTimePicker for table cells and spans.  --}}
//{{-- Use .mytabledatepicker for date-only inputs.                                     --}}
//{{-- Use .mytabledatetimepicker for date-time inputs.                                 --}}
//{{-- Simply add the class to the td.                                                  --}}
//{{-- The tds can be contenteditable and will trigger change events to handle updates  --}}
//{{-- This version supports glb_locale for proper localization.                        --}}
//{{-- Important note: if you're going to use the table cell content after it changes,  --}}
//{{-- do NOT bind to the change event, but rather to our custom datepickerchange event.--}}
//{{-- -------------------------------------------------------------------------------- --}}

//{{-- Instance variables --}}
var tdp_activeDtField = null;
var tdp_activeDtFieldHtml = null;
var tdp_killingDtPicker = false;
var tdp_dateTimeInputField = null;
var tdp_dtPicker = null;
var tdp_isDateTimePicker = false;

$(function () {
    //{{-- Create the hidden input field --}}
    fieldDefinition = "<div style='display:none;'><input class='myDatePickerInput p-0 m-0' id='myDatePickerInput' style='visibility:hidden; font-size: 0rem; height: 0%; width: 0%;'></input></div>"
    $("body").append(fieldDefinition);
    tdp_dateTimeInputField = $("#myDatePickerInput");

    //{{-- Set jQuery UI locale settings based on glb_locale --}}
    $.datepicker.setDefaults($.datepicker.regional[glb_locale] || {});

    //{{-- Handle clicks on date-only fields --}}
    $(document).on('click', '.mytabledatepicker', function (evt) {
        date = $(this).text();
        if (isValidDate(date)) $(this).attr("value", date);
        showDtPicker($(this), false);  // false = DatePicker
    });

    //{{-- Handle clicks on date-time fields --}}
    $(document).on('click', '.mytabledatetimepicker', function (evt) {
        date = $(this).text();
        if (isValidDate(date)) $(this).attr("value", date);
        showDtPicker($(this), true);  // true = DateTimePicker
    });

    $(document).on('keydown', '.mytabledatepicker, .mytabledatetimepicker', function () {
        killDtPicker();
    });

    $(document).on('focusout', '.mytabledatepicker, .mytabledatetimepicker', function () {
        date = $(this).text();
        if (isValidDate(date)) $(this).attr("value", date);
    });
});

//{{-- Check if a string is a valid date --}}
function isValidDate(dtString) {
    return !isNaN(new Date(dtString).getTime());
}

//{{-- "Kills" a currently open date or date-time picker --}}
function killDtPicker() {
    tdp_killingDtPicker = true;
    if (tdp_dtPicker != null && tdp_dtPicker.length > 0) {
        // First heck if the picker is actively being used
        if (document.activeElement === tdp_dateTimeInputField[0]) {
            tdp_killingDtPicker = false; // Don't destroy if it's active
            return;
        }
        tdp_dtPicker[tdp_isDateTimePicker ? 'datetimepicker' : 'datepicker']("hide");
        tdp_dtPicker[tdp_isDateTimePicker ? 'datetimepicker' : 'datepicker']("destroy");
        tdp_dtPicker = null;
        tdp_activeDtField = null;
    }
    tdp_killingDtPicker = false;
}

//{{-- Show the appropriate picker in a table cell --}}
function showDtPicker(parent, isDateTime) {
    tdp_activeDtField = parent;
    tdp_activeDtFieldHtml = tdp_activeDtField.html();
    currDate = tdp_activeDtField.attr('value') || tdp_activeDtField.text().trim();

    tdp_isDateTimePicker = isDateTime; // Set the global variable

    // Set the value of the input field before initializing
    tdp_dateTimeInputField.val(currDate);

    // Clean up any old pickers before moving the input field
    try {
        tdp_dateTimeInputField.datetimepicker("destroy");
        tdp_dateTimeInputField.datepicker("destroy");
    } catch (error) {
        console.warn('Datetimepicker cleanup error:', error);
    }

    // Move the input field to the active table cell
    tdp_activeDtField.append(tdp_dateTimeInputField);

    // Initialize the picker after cleanup
    // Initialize the appropriate picker
    if (isDateTime) {
        tdp_dateTimeInputField.datetimepicker({
            constrainInput: true,
            dateFormat: 'yy-mm-dd',
            timeFormat: 'HH:mm',
            controlType: 'select',
            showTime: false,
            minDate: new Date(),
            beforeShow: function () {
                //console.log('Datetimepicker beforeShow triggered');
            },
            onClose: function () {
                //console.log('Datetimepicker onClose triggered');
                if (!tdp_killingDtPicker) setTimeout(() => hideDtPicker(tdp_activeDtField), 50); // Delay to allow safe handling
            }
        });
    } else {
        tdp_dateTimeInputField.datepicker({
            constrainInput: true,
            dateFormat: 'yy-mm-dd',
            beforeShow: function () {
                //console.log('Datepicker beforeShow triggered');
            },
            onClose: function () {
                //console.log('Datepicker onClose triggered');
                if (!tdp_killingDtPicker) setTimeout(() => hideDtPicker(tdp_activeDtField), 50); // Delay to allow safe handling
            }
        });
    }

    //console.log('Datetimepicker successfully attached to #testDatePicker for:', tdp_activeDtField);

    tdp_dtPicker = tdp_dateTimeInputField;

    // Show the picker
    tdp_dtPicker[isDateTime ? 'datetimepicker' : 'datepicker']("show");
}


//{{-- Hides the picker and updates the field value --}}
function hideDtPicker(parent) {
    if (parent != null && tdp_activeDtField != null) {
        date = tdp_dtPicker[tdp_isDateTimePicker ? 'datetimepicker' : 'datepicker']("getDate");

        let formattedDate = $.datepicker.formatDate('yy-mm-dd', date);

        if (!tdp_isDateTimePicker) {
            date = formattedDate;  //{{--  Date-only format --}}
        } else {
            date = `${formattedDate} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;  // Date-time format
        }

        //{{--  Destroy the picker to clean up --}}
        if (tdp_isDateTimePicker) {
            tdp_dtPicker.datetimepicker("destroy");
        } else {
            tdp_dtPicker.datepicker("destroy");
        }

        //{{--  Update DOM elements --}}
        oldDate = tdp_activeDtField.attr('value');
        tdp_activeDtField.html(tdp_activeDtFieldHtml).attr('value', date).text(date);

        if (oldDate != date) {
            //{{-- Datepicker needs a little time to finish things up here --}}
            setTimeout(() => {
                //{{-- We use a custom trigger because the standard trigger also fires as the user is interacting with the picker UI --}}
                tdp_activeDtField.trigger('datepickerchange').trigger('change');  
            }, 50);
        }
    }
}

